import * as Flex from "@twilio/flex-ui";
import { ITask, TaskHelper, StateHelper } from "@twilio/flex-ui";
import ExceptionLogger from "../../../../../ExceptionHelper";
import { FlexComponent } from "../../../../types/feature-loader";
import FeatureToggleService from "../../../../utils/FeatureToggleService";
import { isColdTransferEnabled, isMultiParticipantEnabled } from "../../config";
import LeaveChatButton from "../../custom-components/LeaveChatButton";
import ParkButton from "../../custom-components/ParkButton";
import TransferButton from "../../custom-components/TransferButton";
import { countOfOutstandingInvitesForConversation } from "../../helpers/inviteTracker";

interface Props {
  task: ITask;
}

export const componentName = FlexComponent.TaskCanvasHeader;
export const componentHook = async function addChatTransferButtons(flex: typeof Flex) {
  try {
    if (isColdTransferEnabled()) {
      flex.TaskCanvasHeader.Content.add(<TransferButton key="conversation-transfer-button" />, {
        sortOrder: 1,
        if: ({ task }) => TaskHelper.isCBMTask(task) && task.taskStatus === "assigned"
      });
    }
    
    const manager = Flex.Manager.getInstance();
    const isParkFeatureOn = await new FeatureToggleService(manager).isParkFeatureOn();
    if(isParkFeatureOn)
    {
      flex.TaskCanvasHeader.Content.add(<ParkButton key="park-chat-button" />, {
        sortOrder: 2
      });
    }

    if (!isMultiParticipantEnabled()) return;

    const replaceEndTaskButton = (task: ITask) => {
      if (TaskHelper.isCBMTask(task) && task.taskStatus === "assigned") {
        // more than two participants or are there any active invites?
        const conversationState = StateHelper.getConversationStateForTask(task);
        if (
          conversationState &&
          (conversationState.participants.size > 2 || countOfOutstandingInvitesForConversation(conversationState))
        )
          return true;
      }
      return false;
    };

    flex.TaskCanvasHeader.Content.add(<LeaveChatButton key="leave-chat" />, {
      if: ({ task }: Props) => replaceEndTaskButton(task)
    });

    flex.TaskCanvasHeader.Content.remove("actions", { if: ({ task }: Props) => replaceEndTaskButton(task) });
  } catch (error) {
    console.error(error);
    ExceptionLogger(error, "addChatTransferButtons", "TaskCanvasHeader.tsx", "","");
  }
};
